import React, { useEffect, useRef } from "react";

export default function StarsBackground({ count = 140 }) {
  const ref = useRef(null);
  const mouse = useRef({ x: 0.5, y: 0.5 });

  useEffect(() => {
    const canvas = ref.current; if (!canvas) return;
    const ctx = canvas.getContext("2d");
    let raf = 0; let w = 0, h = 0; let stars = [];

    const resize = () => {
      w = canvas.width = window.innerWidth * window.devicePixelRatio;
      h = canvas.height = window.innerHeight * window.devicePixelRatio;
      canvas.style.width = window.innerWidth + "px";
      canvas.style.height = window.innerHeight + "px";
      stars = Array.from({ length: count }, () => ({
        x: Math.random() * w,
        y: Math.random() * h,
        z: Math.random() * 0.8 + 0.2,
        r: Math.random() * 1.6 + 0.3,
        tw: Math.random() * Math.PI * 2,
      }));
    };
    const onMove = (e) => {
      mouse.current.x = e.clientX / window.innerWidth;
      mouse.current.y = e.clientY / window.innerHeight;
    };
    const tick = (t) => {
      ctx.clearRect(0, 0, w, h);
      const mx = (mouse.current.x - 0.5) * 30 * window.devicePixelRatio;
      const my = (mouse.current.y - 0.5) * 30 * window.devicePixelRatio;
      for (const s of stars) {
        s.tw += 0.02;
        const flicker = (Math.sin(s.tw) + 1) / 2; // 0..1
        const px = s.x + mx * s.z;
        const py = s.y + my * s.z;
        const alpha = 0.25 + flicker * 0.7 * s.z;
        ctx.beginPath();
        ctx.fillStyle = `rgba(${200 + Math.floor(s.z * 55)}, ${190 + Math.floor(flicker * 50)}, 255, ${alpha})`;
        ctx.arc(px, py, s.r * s.z, 0, Math.PI * 2);
        ctx.fill();
      }
      raf = requestAnimationFrame(tick);
    };
    resize();
    window.addEventListener("resize", resize);
    window.addEventListener("mousemove", onMove);
    raf = requestAnimationFrame(tick);
    return () => { cancelAnimationFrame(raf); window.removeEventListener("resize", resize); window.removeEventListener("mousemove", onMove); };
  }, [count]);

  return (
    <canvas ref={ref} className="fixed inset-0 z-0 pointer-events-none" aria-hidden />
  );
}
